module.exports = __webpack_public_path__ + "img/52.78649808.png";